import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        name: 'Home',
        path: '/',
        component: () => import("../views/Homeview.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'signup',
        path: '/signup',
        component: () => import("../views/SignUp.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'login',
        path: '/login',
        component: () => import("../views/Login.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'loginWithPhone',
        path: '/login-with-phone',
        component: () => import("../views/LoginWithPhone.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'ShopView',
        path: '/shop',
        component: () => import("../views/Shopview.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'BlogView',
        path: '/blog',
        component: () => import("../views/Blogview.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'AboutView',
        path: '/about',
        component: () => import("../views/Aboutview.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'ProductDetailsview',
        path: '/ProductDetails/:id',
        component: () => import("../views/ProductDetailsview.vue"),
        meta: { authRequired: false },
    },
    {
        name: 'Cartview',
        path: '/cart',
        component: () => import("../views/Cartview.vue"),
        meta: { authRequired: true },
    },
    {
        name: 'PageNotFound',
        path: '/:pathMatch(.*)*',
        component: () => import("../views/PageNotFound.vue"),
        meta: { authRequired: false },
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: 'active',
    linkExactActiveClass: "nav-link",
})

router.beforeEach((routeTo, routefrom, next) => {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
        const isAuth = localStorage.getItem('isAuth')
        
        if (authRequired && !isAuth) {
        next('/login')
    } else {
        next()
    }
})
export default router;
